"use strict";function compressVideo$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.compressVideo$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.media.compressVideo";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.37"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.6.37"},_a)),exports.compressVideo$=compressVideo$,exports.default=compressVideo$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/media/compressVideo.js
// module id = 967
// module chunks = 106